import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import CreateVisitorViewPageForm from "./CreateVisitorViewPageForm";
import { UserContext } from "../../Context/UserContext";
import { BaseURL } from "../../Reusable/BaseURL";

export default function CreateVisitorView() {
  const {
    darkTheme,
    loginData,
    setIndentCreateItemId4Upd,
    setQuotationIndentId,
    setQuotationPartyId,
    setGetGateVisitorInfo,
  } = useContext(UserContext);

  const [indent, setIndent] = useState("");
  const [party, setParty] = useState("");
  const [getEnquiries, setGetEnquiries] = useState([]);

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(true);

  const [addMoreToggle, setAddMoreToggle] = useState(false);
  const [changingSelect, setChangingSelect] = useState(false);

  const [submitAction, setSubmitAction] = useState("submit");
  // disabled action
  const [editDisable, setEditDisable] = useState(false);

  const [unsavedIndentItem, setUnsavedIndentItem] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    getEnquiry();
    setGetGateVisitorInfo({});
  }, []);

  // create
  const selectedPartyId = party && party.map((item, index) => item.value);
  async function createDivision(e) {
    e.preventDefault();

    const formData = {
      indent_id: indent.value,
      party_id: selectedPartyId,
    };
    console.log(formData);

    const res = await fetch(`${BaseURL}/purchase/enquiry/save`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          toast.success("Success");
        }
        if (createRes?.error?.message.date) {
          toast.error(createRes.error.message.date);
        } else if (createRes?.error?.message.severity) {
          toast.error(createRes.error.message.severity);
        }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/states?page=1`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((li) => {
        if (li?.status) {
          const revData = li.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(li.data.total);
          setFrom(li.data.from);
          setTo(li.data.to);
          setLinks(li.data.links);
          setSpinner(false);
        }
      });
  }

  function editBtn(id) {
    setEditDisable(true);
    fetch(`${BaseURL}/gate-entry/get/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((selectedRecord) => {
        if (selectedRecord.status) {
          // setChangingSelect(true);
          // setQuotationIndentId(selectedRecord.data.indent.id)
          // setQuotationPartyId(selectedRecord.data.party.id)
          setSubmitAction("update");
          setGetGateVisitorInfo(selectedRecord.data);
          navigate("/gate-entry/create-entry-visitors");
          setEditDisable(false);

          // setDivision(selectedRecord.data.division || "");
        } else {
          setEditDisable(false);
        }
      });
    // setChangingSelect(false);
  }

  // GET all gate entry visitors function
  async function getEnquiry() {
    const response = await fetch(`${BaseURL}/gate-entry/getall`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    });
    const data = await response.json();
    if (data.status) {
      setSpinner(false);
      const reverseOrder = data.data.reverse();
      // setGetEnquiries(data.data);
      setGetEnquiries(reverseOrder);
    }
    if (data.status === false) {
      setSpinner(false);
      toast.error("Slow Internet or No Records");
    }
  }

  function cancelUpdate() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setSubmitAction("submit");
  }
  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Visitors Entry View
          </div>
          <div
            // className="grid grid-cols-1 gap-8 md:gap-1 lg:gap-4 md:grid-cols-2"
            className="flex flex-col gap-8 md:gap-1 lg:gap-4"
          >
            <div className="px-2 w-full mb-6">
              <form>
                {/* <div className="flex flex-wrap gap-x-2 md:gap-x-6 gap-y-3">
                  <div className="mb-2 min-w-[320px]">
                    <label>Indent</label>
                    <IndentSelect
                      selectedOption={indent}
                      setSelectedOption={setIndent}
                      changingSelect={changingSelect}
                      getIndent={getIndent}
                    />
                  </div>

                  <div className="flex flex-wrap gap-2">
                    <div className="min-w-[320px]">
                      <label>Party</label>
                      <PartySelect
                        selectedOption={party}
                        setSelectedOption={setParty}
                        changingSelect={changingSelect}
                      />
                    </div>
                    <Link to="/master/supplier" target="_blank">
                      <button className="bg-green-600 rounded-md px-4 py-1.5 text-white">
                        Create Party
                      </button>
                    </Link>
                  </div>
                </div> */}
              </form>
            </div>

            <div className="w-full px-2">
              <CreateVisitorViewPageForm
                editBtn={editBtn}
                editDisable={editDisable}
                // firstPageList={firstPageList}
                links={links}
                firstPage={getEnquiries}
                setGetId={setGetId}
                spinner={spinner}
                totalNo={totalNo}
                from={from}
                to={to}
                addMoreToggle={addMoreToggle}
                setAddMoreToggle={setAddMoreToggle}
                getQuotationFun={getEnquiry}
              />
            </div>

            {/* {submitAction === "submit" && (
              <div className="flex items-center justify-center gap-x-1 mt-2">
                <Button type="submit" onClick={(e) => createDivision(e)}>
                  Send
                </Button>
                <Button type="button" onClick={() => cancelUpdate()}>
                  Clear
                </Button>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
}
